const Package = [
  {
    id: 13,
    name: 'XOXO SHIRT - ROYAL BLUE',
    href: '#',
    price: '2000',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/XOXOFront.jpg?v=1715274856&width=800',
    imageAlt: 'XOXO SHIRT - ROYAL BLUE',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 14,
    name: 'GOLFFATHER POLO SHIRT - IVORY WHITE',
    href: '#',
    price: '2500',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/GolffatherFront.png?v=1715326194&width=800',
    imageAlt: 'GOLFFATHER POLO SHIRT - IVORY WHITE',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 15,
    name: 'DATEJUST SHIRT - BOTTLE GREEN',
    href: '#',
    price: '1500',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/dateJustfront.png?v=1715326149&width=800',
    imageAlt: 'DATEJUST SHIRT - BOTTLE GREEN',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 16,
    name: 'LEAN T-SHIRT- VINTAGE WASH',
    href: '#',
    price: '3500',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/1_53.jpg?v=1713195154&width=800',
    imageAlt: 'Hand holding black machined steel mechanical pencil with brass tip and top.',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 17,
    name: 'GODSPEED TEE',
    href: '#',
    price: '1000',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/14_c442103f-348c-4c9f-88c9-6ee398b74764.png?v=1714808609&width=800',
    imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 18,
    name: 'MORE DEAD THAN ALIVE BLACK TEE',
    href: '#',
    price: '1000',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/IMG_6413_1.jpg?v=1715451060&width=800',
    imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 19,
    name: 'MEMBERS ONLY CLUB - NOT WHITE',
    href: '#',
    price: '1200',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/MEMBERSONLYCLUB-NOTWHITE.jpg?v=1710421718&width=1400',
    imageAlt: 'Person using a pen to cross a task off a productivity paper card.',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 20,
    name: 'ULTIMATE SNEAKER HOODIE',
    href: '#',
    price: '4000',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/61_523e94ac-6e1b-47d6-890c-89e1351ff199.jpg?v=1711648894&width=1800',
    imageAlt: 'Hand holding black machined steel mechanical pencil with brass tip and top.',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 21,
    name: 'TAPIOCA OVERSIZED HOODIE',
    href: '#',
    price: '3000',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/68_4037b2b4-4e18-446c-9122-8b5ef7a0b70f.png?v=1710577905&width=1800',
    imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 22,
    name: 'CORDUROY CAP - BROWN',
    href: '#',
    price: '900',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/LMC5634_1.jpg?v=1711101014&width=800',
    imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 23,
    name: `'IF THIS ISN'T ME' CAP`,
    href: '#',
    price: '890',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/LMC3496.jpg?v=1710932496&width=800',
    imageAlt: 'Person using a pen to cross a task off a productivity paper card.',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
  {
    id: 24,
    name: 'CORDUROY CAP - BLACK',
    href: '#',
    price: '900',
    imageSrc: 'https://crepdogcrew.com/cdn/shop/files/LMC5634_7c4842fa-d577-46cc-bfb7-74bb6ba3768f.jpg?v=1711101020&width=800',
    imageAlt: 'Hand holding black machined steel mechanical pencil with brass tip and top.',
    Size1:'S',
    Size2:'M',
    Size3:'L',
    Size4:'XL',
  },
]
export default Package;